<template>

    <page-tabs
      :tabs="tabs"
    >
    <template v-slot:default="{tabSelected}">
      <pays v-if="tabSelected==='pays'" :filter.sync="filter"/>
      <pays-report v-if="tabSelected==='paysReport'" :filter.sync="filter"/>
      <devices v-if="tabSelected==='devices'" :filter.sync="filter"/>
    </template>
  </page-tabs>

</template>

<script>
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import Pays from "@/views/Pay/Pays";
import Devices from "@/views/Device/Devices.vue";
import PaysReport from "@/views/Pay/PaysReport.vue";
import moment from "moment/moment";

export default {
  components: {PageTabs, PaysReport, Devices, Pays},
  data:()=>({
    tabs: [
      { 
        name: 'pays', 
        perm: 'financesOperation', 
        label: 'Операции', 
      },
      { 
        name: 'paysReport', 
        perm: 'financesReport', 
        label: 'Отчет', 
      },
      { 
        name: 'devices', 
        perm: 'financesDevice', 
        label: 'Кассовое оборудование', 
      },
    ],
    filter: {
      dateFrom:moment().format('YYYY-MM-DD 00:00:00'),
      dateTo:moment().format('YYYY-MM-DD 23:59:59'),
      typesSelected:[],
      sourcesSelected:[],
    }
  })
}
</script>


